/**
 * Tile.jsx - KPI summary tile.
 *
 * Renders a metric card with an accent left-border, a small label,
 * a large value, and an optional note line beneath the value.
 *
 * Props:
 *   label    {string}  - Short uppercase label (e.g. "Total Vendors").
 *   value    {node}    - The primary metric value (string, number, or element).
 *   note     {string}  - Optional secondary text below the value.
 *   variant  {string}  - "good" | "warn" | "bad" | undefined (default accent).
 *                        Controls the left-border accent color.
 *
 * Usage:
 *   <Tile label="Total Vendors" value={142} />
 *   <Tile label="On-Time Rate" value="94%" note="+2% vs last quarter" variant="good" />
 */

export default function Tile({ label, value, note, variant }) {
  const className = variant ? `tile ${variant}` : "tile";

  return (
    <div className={className}>
      <div className="tile-label">{label}</div>
      <div className="tile-value">{value}</div>
      {note && <div className="tile-note">{note}</div>}
    </div>
  );
}
